
<template>
  <!--用户反馈-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="feedbackId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      @resetSearch = "resetSearch"
      :rowSelection="false">

      <template slot="opt_h" slot-scope="{row}">
        <a-tooltip :title="row.msgContent">
          <div class="feed-over-text" @click="showDetail(row.msgContent)">{{row.msgContent}}</div>
        </a-tooltip>
      </template>

      <template slot="opt_t" slot-scope="{row}">
        <a-button type="link" style="height:28px" v-if="row.statusDesc==='已回复'" href="#" @click="showInfo(row)">{{row.statusDesc}}</a-button>
        <span v-else>{{row.statusDesc}}</span>
      </template>
    </x-tabula>

    <!--已回复的弹窗-->
    <a-modal
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      v-bind="modalConfig"
      :width="900"
    >
      <a-form :form="form">
        <a-row>
          <a-col
            v-for="(item, index) of answerList"
            :key="index"
            :span="item.span">
              <a-form-item
                v-if="item.show && item.label!=='回复'"
                v-bind="item.layout"
                :label="item.label">
                <span :style="{maxWidth: '700px'}" class="ant-form-text">{{item.value}}</span>
              </a-form-item>
              <a-form-item
                v-if="item.show && item.label==='回复'"
                v-bind="item.layout"
                :label="item.label">
                <a-textarea
                  v-decorator="['msgContent', decoratorOptions.msgContent]"
                  rows="4"
                  placeholder="请输入回复内容"></a-textarea>
              </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>

    <!--回复内容详情的弹窗-->
    <a-modal
      title="反馈详情"
      :visible="feedBackVisible"
      @cancel="feedBackVisible=false"
      :footer="null"
      :maskClosable="true"
      :keyboard="true"
      destroyOnClose
      centered
      :width="900"
    >
      <div>{{feedBackContent}}</div>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'feedBack',
  data () {
    let layout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 9 }
    };
    let longLayout = { labelCol: { span: 4 }, wrapperCol: { span: 17 } };
    return {
      apiOrigin: 'PHP',
      feedBackContent: '',
      feedBackVisible: false,
      feedbackId: '',
      modalConfig: {},
      visible: false,
      btnLoading: { loading: false },
      decoratorOptions: {
        msgContent: {
          validateTrigger: 'blur',
          rules: [{required: true, message: '请输入回复内容'}, {pattern: this.REG.nonEmpty, message: this.MESSAGE.nonEmpty}]
        }
      },
      searchList: [
        { props: ['keywords'], placeholder: '昵称、手机号', inputType: 'input' },
        { props: ['communityId'], placeholder: '小区', options: [], inputType: 'select', fetchOptions: this.getOptions },
        { props: ['appId'], placeholder: '应用', options: [], inputType: 'select' },
        { props: ['msgStatus'], placeholder: '回复状态', options: this.$store.state.feedBackStatusSelect, inputType: 'select' },
        { props: ['createTime'], placeholder: ['反馈时间', '反馈时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '回复', handle: (row) => this.answer(row), rowOptDisHandle: row => row.statusDesc === '已回复', permi: ['community:feedback:answer'] },
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:feedback:remove'] }
      ],
      columns: [
        { title: '昵称', dataIndex: 'userName', align: 'left', width: '' },
        { title: '账号', dataIndex: 'mobilePhone', align: 'left', width: '' },
        { title: '小区', dataIndex: 'communityName', align: 'left', width: '' },
        { title: '应用', dataIndex: 'appDesc', align: 'left', width: '' },
        { title: '反馈内容', dataIndex: 'msgContent', align: 'left', width: '', scopedSlots: {customRender: 'h'} },
        { title: '反馈时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      answerList: [
        { key: 'mobilePhone', label: '账号', value: '', span: 12, layout: layout, show: true },
        { key: 'userName', label: '昵称', value: '', span: 12, layout: layout, show: true },
        { key: 'appDesc', label: '应用', value: '', span: 12, layout: layout, show: true },
        { key: 'communityName', label: '小区', value: '', span: 12, layout: layout, show: true },
        { key: 'createTime', label: '反馈时间', value: '', span: 24, layout: longLayout, show: true },
        { key: 'msgContent', label: '反馈内容', value: '', span: 24, layout: longLayout, show: true },
        { key: 'msgContent', label: '回复', value: '', span: 24, layout: longLayout, show: true }, // 回复部分
        { key: 'answerContent', label: '回复内容', value: '', span: 24, layout: longLayout, show: true }, // 查看部分
        { key: 'answerName', label: '回复人', value: '', span: 12, layout: layout, show: true }, // 查看部分
        { key: 'answerTime', label: '回复时间', value: '', span: 12, layout: layout, show: true } // 查看部分
      ],
      dataSource: [],
      searchParams: {
        keywords: '',
        communityId: '',
        appId: '',
        msgStatus: '',
        createTime: ''
      },
      listApi: {
        url: '/feedback/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {},
      deleteParam: {
        url: '/feedback/',
        // param: {pk_key: 'feedbackId', pk_val: ''},
        title: '用户反馈',
        key: 'userName'
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '1');
      this.searchList[1].searchValue = undefined;
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '1');
    },
    getSelect () {
      // this.communitySelect(1, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '1');
      this.dictionarySelect([{index: 2, scope: 'searchList', query: 'comu_app_type'}]);
    },
    /* 查看回复内容 */
    showDetail (content) {
      this.feedBackContent = content;
      this.feedBackVisible = true;
    },
    /* 查看信息 */
    showInfo (row) {
      this.modalConfig = {
        title: '反馈详情',
        footer: null,
        maskClosable: true,
        keyboard: true
      };
      this.answerList.forEach((el) => {
        el.show = true;
      });
      this.loopSetVal(row, ['回复']);
      this.visible = true;
    },
    /* 回复 */
    answer (row) { // 多了回复内容、回复人
      this.modalConfig = {
        title: '回复',
        maskClosable: false,
        keyboard: false
      };
      this.answerList.forEach((el) => {
        el.show = true;
      });
      this.feedbackId = row.feedbackId;
      this.loopSetVal(row, ['回复内容', '回复人', '回复时间']); // 需隐藏的数组
      this.visible = true;
    },
    loopSetVal (row, modelArr) {
      for (let item in row) {
        this.answerList.forEach((el) => {
          if (item === el.key) {
            el.value = row[item];
          }
        });
      }
      this.answerList.forEach((el) => {
        modelArr.forEach((item) => {
          if (item === el.label) {
            el.show = false;
          }
        });
      });
    },
    /* 点击确定弹窗 */
    confirm () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        values = Object.assign(values, {feedbackId: this.feedbackId});
        this.$post({
          url: '/feedback/answer',
          params: {
            feedbackId: this.feedbackId,
            ...values
          },
          btnLoading: this.btnLoading
        }).then((res) => {
          this.$message.success('回复成功！');
          this.visible = false;
          this.$refs.table.getTableList();
        });
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
